import { Injectable } from '@angular/core';
import notify from 'devextreme/ui/notify';
import { MessageBoxOptions } from '@base/classes/BaseClasses';
import { SysEventsService } from '@core/framework/sysevents.service';

@Injectable()
export class UiService {

    constructor(private sysEventsService: SysEventsService) {
    }

    public OpenMessageBox(options: MessageBoxOptions) {
        this.sysEventsService.OpenMessageBox(options);
    }

    public CloseMessageBox(result: boolean) {
        this.sysEventsService.CloseMessageBox(result)
    }

    // Information message for the user
    public WarningMessage(sMessage: string, sSelector?: string) {
        this.ShowMessage(sMessage, 'warning', 30000, sSelector);
    }

    // Information message for the user
    public InfoMessage(sMessage: string, sSelector?: string, iMilliSecs?: number) {
        this.ShowMessage(sMessage, 'success', iMilliSecs || 5000, sSelector);
    }

    // Error message for the user
    public StopMessage(sMessage: string, sSelector?: string, iMilliSecs?: number,) {
        this.ShowMessage(sMessage, 'error', iMilliSecs || 15000, sSelector);
    }

    public Notify(sMessage: string) {
        this.ShowMessage(sMessage, 'info', 15000, undefined, true);
    }

    // Differentiate between user messages and message that system has no expected
    // For instance, getting an error when populating a combo is not expected. 
    // An error message when saving an entity can happen, thus StopMessage should be used
    public UnexpectedMessage(sMessage: string) {
        this.ShowMessage(sMessage, 'info', 15000);
        console.error(sMessage);
    }

    // Show the message
    private ShowMessage(sMessage: string, sType: string, iMilliSecs: number, sSelector?: string, isNotification?: boolean) {
        const toasts = document.querySelectorAll('.dx-toast-content');
        const options = this.GetNotifyOptions(sMessage, sSelector, toasts, isNotification);
        const displayTime = iMilliSecs - toasts.length * 1000;

        notify(options, sType, displayTime <= 5000 ? 5000 : displayTime);
    }

    private GetNotifyOptions(sMessage: string, sSelector: string, toasts: NodeListOf<Element>, isNotification?: boolean) {
        const position = isNotification ? 'right bottom' : 'bottom center';
        const offset = isNotification ? `-20px -${this.GetNotificationTop(toasts)}` : '0 -20px';
        return {
            message: sMessage,
            closeOnClick: true,
            closeOnSwipe: true,
            width: 200,
            position: {
                at: position,
                my: position,
                of: sSelector || null,
                offset: offset
            },
            show: {
                duration: 0
            },
            animation: {
                show:
                {
                    type: 'fade',
                    duration: 0,
                    from: 0,
                    to: 1
                },
                hide:
                {
                    type: 'fade',
                    duration: 1000,
                    from: 1,
                    to: 0
                }
            }
        };
    }

    private GetNotificationTop(toasts: NodeListOf<Element>): number {
        let top = 0;
        const lastOffset = toasts.length ? toasts[toasts.length - 1]?.getBoundingClientRect().top : null;

        if (lastOffset) {
            top = lastOffset;
        }
        if (top <= 0) {
            top = 20;
        }
        else {
            top = window.innerHeight - top;
            top += 5;
        }

        return top;
    }
}
